export const localeCodeMap = {
  enUs: 'en-US',
  jaJp: 'ja-JP',
} as const

export type LocaleCodeValues =
  (typeof localeCodeMap)[keyof typeof localeCodeMap]
